import React from 'react';
import { Text } from '@amzn/stencil-react-components/text';
import { Row } from '@amzn/stencil-react-components/layout';
import { IconCheckCircleFill, IconSize } from '@amzn/stencil-react-icons';
import { WidgetView, WidgetViewProps } from 'src/models/WidgetView';

interface WorkflowActionCompletedView extends WidgetViewProps {}
const WorkflowActionCompletedView: WidgetView = () => {
  return (
    <Row>
      <Text fontWeight={'bold'}>Your action has been completed</Text>
      <IconCheckCircleFill color={'green80'} size={IconSize.Medium} />
    </Row>
  );
};

export default WorkflowActionCompletedView;
